enum WaterEventTypes {
    leak = "Leak",
    abnormal = "Abnormal",
    lowUsage = "Low Usage",
    noFlow = "No Flow",
}

export default WaterEventTypes;